import { mapGetters } from "vuex";
import { Toast } from "vant";
export const comment = {
    data() {
        return {
            actInfo: {},
            userInfo: {}
        }
    },
    computed: {
        ...mapGetters(['getGroundMarketingInfo']),
        ListBgc: function() {
            let result = "";
            result = this.actInfo.cardBagBackgroundImg? `url(${this.actInfo.cardBagBackgroundImg})`: '';
            return result;
        },
        homeBgc: function() {
            let result = "";
            result = this.actInfo.actBackgroundImg? `url(${this.actInfo.actBackgroundImg})`: '';
            return result;
        },
        cardFromTheTopValue: function() {
            let result = '';
            result = this.actInfo.cardFromTheTopValue? this.actInfo.cardFromTheTopValue: '120px';
            return result;
        },
        btnFontColor: function() {
            let result = "";
            result = this.actInfo.btnFontColor? this.actInfo.btnFontColor: '#553000';
            return result;
        },
        btnBgcColor: function() {
            let result = "";
            result = this.actInfo.btnBgcColor? this.actInfo.btnBgcColor: 'linear-gradient(to right, #F6D5B2, #ECB884)';
            return result;
        },
        cardBgc: function() {
            let result = "";
            result = this.actInfo.cardBgc? this.actInfo.cardBgc: 'background-color: rgba(255, 255, 255, .4)';
            return result;
        },
        loginBoxFromTheTopValue: function() {
            let result = "";
            result = this.actInfo.loginBoxFromTheTopValue? this.actInfo.loginBoxFromTheTopValue: '233px';
            return result;
        }
    },
    methods: {
        activityRule() {
          this.$router.push({name: "groundMarketingRule"});
        },
        myGiftBtn() {
          this.$router.push({name: "groundMarketingGiftList"});
        },
        init() {
            return new Promise((resolve, reject) => {
                if (!this.getGroundMarketingInfo) return Toast("无法获取活动信息");
                let {actInfo, userInfo} = this.getGroundMarketingInfo;
                this.actInfo = actInfo;
                this.userInfo = userInfo;
                resolve(true);
            })
        }
    }
}